import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/CurrencyController/CreateCurrencyController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateCurrency({ currency, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        vc_CurrencyName: '', vc_CurrencyCode: '', vc_CurrencySymbol: '', dec_CurrencyToBaseRate: '0.00',
        dec_BaseToCurrencyRate: '0.00', vc_MajorCurrency: '0.00', vc_MinorCurrency: '0.00',
        bit_BaseCurrency: 0
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (currency) {
            setFormData({
                vc_CurrencyName: currency.vc_CurrencyName, vc_CurrencyCode: currency.vc_CurrencyCode,
                vc_CurrencySymbol: currency.vc_CurrencySymbol, dec_CurrencyToBaseRate: currency.dec_CurrencyToBaseRate,
                dec_BaseToCurrencyRate: currency.dec_BaseToCurrencyRate, vc_MajorCurrency: currency.vc_MajorCurrency,
                vc_MinorCurrency: currency.vc_MinorCurrency,
                bit_BaseCurrency: currency.bit_BaseCurrency
            });
        } else {
            setFormData({
                vc_CurrencyName: '', vc_CurrencyCode: '', vc_CurrencySymbol: '', dec_CurrencyToBaseRate: '0.00',
                dec_BaseToCurrencyRate: '0.00', vc_MajorCurrency: '0.00', vc_MinorCurrency: '0.00', bit_BaseCurrency: 0
            }); // Clear form data when switching to add mode
        }
    }, [currency]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        debugger;
        event.preventDefault(); // Prevent default form submission
        if (currency) {
            formData.ID = currency.PK_Currency_ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="currencyModal" tabIndex="-1" aria-labelledby="currencyModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{currency ? "Edit Currency" : "Add Currency"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Currency Name:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_CurrencyName" value={formData.vc_CurrencyName} onChange={handleFieldChange} />
                                        {errors.vc_CurrencyName && <div style={{ color: 'red' }}>{errors.vc_CurrencyName}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Currency Code:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_CurrencyCode" value={formData.vc_CurrencyCode} onChange={handleFieldChange} maxLength={3} />
                                        {errors.vc_CurrencyCode && <div style={{ color: 'red' }}>{errors.vc_CurrencyCode}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Currency Symbol:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_CurrencySymbol" value={formData.vc_CurrencySymbol} onChange={handleFieldChange} />
                                        {errors.vc_CurrencySymbol && <div style={{ color: 'red' }}>{errors.vc_CurrencySymbol}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Base Currency:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="dec_CurrencyToBaseRate" value={formData.dec_CurrencyToBaseRate} onChange={handleFieldChange} />
                                        {errors.dec_CurrencyToBaseRate && <div style={{ color: 'red' }}>{errors.dec_CurrencyToBaseRate}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Exchange Rate:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="dec_BaseToCurrencyRate" value={formData.dec_BaseToCurrencyRate} onChange={handleFieldChange} />
                                        {errors.dec_BaseToCurrencyRate && <div style={{ color: 'red' }}>{errors.dec_BaseToCurrencyRate}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Major Currency Unit:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_MajorCurrency" value={formData.vc_MajorCurrency} onChange={handleFieldChange} />
                                        {errors.vc_MajorCurrency && <div style={{ color: 'red' }}>{errors.vc_MajorCurrency}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>

                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Minor Currency Unit:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_MinorCurrency" value={formData.vc_MinorCurrency} onChange={handleFieldChange} />
                                        {errors.vc_MinorCurrency && <div style={{ color: 'red' }}>{errors.vc_MinorCurrency}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Is Base Currency:</label>
                                    <div className="col-sm-4">
                                        <select name="bit_BaseCurrency" className='form-control' value={formData.bit_BaseCurrency}
                                            onChange={handleFieldChange}
                                        >
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {currency ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateCurrency;